// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "micro-base-static/css/" + (chunkId === 699 ? "system" : chunkId) + "." + {"493":"31f1b10b","699":"f8683ac4","960":"1190009f"}[chunkId] + ".chunk.css";
};